import React, {useContext, useEffect, useState} from "react";
import {UseContext} from "../context";
import {Navigate, useNavigate} from "react-router-dom";
import timeimg from "../image/back-in-time(1) 1.svg";
import leftarrow from "../image/leftarrow.svg";
import Loadingcom from "./allcomponent/Loading";
import axios from "axios";
import {url} from "../url";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { FaCheck as CheckIcon } from 'react-icons/fa';
import PendingApprovalScreen from "./allcomponent/PendingApproval";


const Historycom = () => {
    const {
        Showhistoryoftr,
        setShowhistoryoftr,
        showtrinprogress,
        setShowtrinprogress,
        showhis,
        setShowhis,
        shownav,
        setShowhistrinprogress,
        getprofloading,
        getmyprof,
        setShownav,
        allactivetravel,
        setAllactivetravel,
        activeloading,
        setActiveloading,
        erroractivet,
        setErroractivet,
        showexit,
        allhistorytravel,
        setAllhistorytravel,
        historyloading,
        setHistoryloading,
        errorhistoryt,
        setErrorhistoryt,
    } = useContext(UseContext);


    const [noActiveTravel, setNoActiveTravel] = useState(false);
    const navigate = useNavigate();
    const handleshowhistoryoftr = (item) => {
        if (item.status === "active" ) {
            setShownav(false);
            navigate(`/history/Activetravel/${item._id}`);
            setShowhistrinprogress(true);
        }else {
            setShownav(false);
            navigate(`/history/travelhistory/${item._id}`);
            setShowhistrinprogress(false);
        }
    };


    const handleshowhistroyprogress = (item) => {
        setShownav(false);
        navigate(`/history/Activetravel/${item._id}`);
        setShowhistrinprogress(true);
    };


    useEffect(() => {
        setActiveloading(true);
        setNoActiveTravel(false)
        if (showtrinprogress) {
            axios
                .get(`${url}/travel/v1/get-active-travel-driver`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                })
                .then((res) => {
                    setAllactivetravel(res.data.data);
                    setActiveloading(false);
                })
                .catch((error) => {

                    if (error.response) {
                        setActiveloading(false)
                        if (error?.response?.status === 404) {
                            setNoActiveTravel(true)
                        } else {
                            setErroractivet(error?.response?.data?.message);
                            setActiveloading(true)
                        }
                    }

                    if (error?.message === "Network Error") setActiveloading(true);
                });
        }

    }, [Showhistoryoftr, showhis, showtrinprogress, setActiveloading, setAllactivetravel, setErroractivet]);


    useEffect(() => {
        setHistoryloading(true)
        if (showhis) {
            axios
                .get(`${url}/travel/v1/get-all-travels-driver`, {
                    headers: {
                        "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                })
                .then((res) => {
                    console.log(res)
                    if (res.status === 200) {
                        setAllhistorytravel(res.data.data.docs);
                    }
                    setHistoryloading(false);
                })
                .catch((error) => {
                    setHistoryloading(true);
                    console.log(error);
                    if (error.response) {
                        if (error?.response?.status === 404) {
                            setErrorhistoryt("سفری یافت نشد ");
                        } else setErrorhistoryt(error.response.data.message);
                    }

                });
        }

    }, [Showhistoryoftr, showhis, showtrinprogress, setAllhistorytravel, setErrorhistoryt, setHistoryloading]);


    const handleshowhis = () => {
        setShowhistoryoftr(false);
        setShowhis(true);
        setShowtrinprogress(false);


    };
    const handleshowtravelinprogress = () => {
        setShowhistoryoftr(false);
        setShowtrinprogress(true);
        setShowhis(false);
    };

    const groupedByDate = allhistorytravel.reduce((all, item) => {
        const date = item.travel_date;
        if (!all[date]) {
            all[date] = [];
        }
        all[date].push(item);
        return all;
    }, {});


    const groupedArray = Object.entries(groupedByDate);


    return (<>
        {localStorage.getItem("token") !== null ? (<>
            {getprofloading === false ? (<>
                {getmyprof.status === "profile_not_completed" ? (
                    <Navigate to="/UserandCarinformation"/>) : (<>
                    {getmyprof.status === "pending" ? (<div
                        className="w-full flex flex-col h-full  overflow-auto mb-[100px] lg:mb-[88px]">
                        <PendingApprovalScreen />
                    </div>) : (<div
                        id="historydiv"
                        className={`w-full flex flex-col h-full ${erroractivet && showhis === false ? "mb-[160px]" : ""}   `}
                    >
                        {Showhistoryoftr === false && shownav === true && (<>
                            <div className="grid grid-cols-2 text-[16px] font-medium mt-6 ">
                                <div className=" flex-row">
                                    <div
                                        className="flex justify-center cursor-pointer"
                                        onClick={handleshowhis}
                                    >
                                        <p> سفر های شما</p>
                                    </div>
                                    {showhis === true && showtrinprogress === false && (<>
                                        <div
                                            className="h-[4px] w-[100%] bg-black rounded-[3px] mt-4"></div>
                                    </>)}
                                </div>
                                <div className="flex-row">
                                    <div
                                        className="flex justify-center cursor-pointer"
                                        onClick={handleshowtravelinprogress}
                                    >
                                        <p>سفر های فعال</p>
                                    </div>
                                    {showtrinprogress === true && showhis === false && (<>
                                        <div
                                            className="h-[4px] w-[100%] bg-black rounded-[3px] mt-4"></div>
                                    </>)}
                                </div>
                            </div>

                            {showhis === true && showtrinprogress === false &&
                                (<div
                                    id="historydiv"
                                    className="space-y-3 mb-[126px]  h-full flex flex-col  overflow-auto"
                                >
                                    <>
                                        {historyloading === false ?
                                            (<>
                                                {groupedArray.map(([date, items]) => (
                                                    <div key={date}>
                                                        <div
                                                            className="text-[12px] font-medium  text-center pt-2">
                                                            <DatePicker
                                                                calendar={persian}
                                                                locale={persian_fa}
                                                                value={date}
                                                                readOnly
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    outline: "none",
                                                                    border: "none",
                                                                    width: "100px",
                                                                    fontSize: "18px",
                                                                }}
                                                            />
                                                        </div>
                                                        {items.map((item, idx) => (<div
                                                            key={item._id}
                                                            className={`${showexit === false ? "cursor-pointer" : ""}  pb-4 flex-row bg-historydivc rounded-[10px] mx-4 shadow-md border-[1px] border-gray-200 mt-4 border-[1px] ${idx === 0 ? "mt-2" : ""}`}
                                                            onClick={showexit === false ? () => handleshowhistoryoftr(item) : null}
                                                        >
                                                            <div
                                                                className=" flex items-center justify-center">
                                                                <p className="text-[16px] font-black text-desc p-4">
                                                                    {item?.origin_city?.name}
                                                                </p>
                                                                <div
                                                                    className="flex items-center gap-1 ">
                                                                    <div
                                                                        className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]"></div>
                                                                    <div
                                                                        className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]"></div>
                                                                    <div
                                                                        className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]  "></div>
                                                                    <div
                                                                        className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]  "></div>
                                                                    <div
                                                                        className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]  "></div>
                                                                    <div
                                                                        className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]  "></div>
                                                                    <div
                                                                        className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]  "></div>
                                                                    <div
                                                                        className="mt-[3px] font-black text-xl text-bordercircle">&gt;</div>
                                                                </div>

                                                                <p className="text-[16px] font-black text-desc p-4">{item?.destination_city?.name}</p>
                                                            </div>

                                                            <div
                                                                className="border-[1px] h-[1px] border-lightline mx-4 mt-1"></div>
                                                            <div
                                                                className="flex gap-4 mx-4 mt-4">
                                                                <div
                                                                    className="w-[30%] h-[26px] rounded-[7px] flex gap-2 items-center ">
                                                                    <p className={`text-[12px] flex justify-center items-center font-medium h-full ${item.status === "active" && `bg-bluetext`} ${item.status === "completed" && `bg-greentext`} ${item.status === "canceled" && `bg-detailcolor`} rounded-[7px] w-full`}>
                                                                        {item.status === "active" &&
                                                                            <span
                                                                                className="text-white flex gap-1">
                                                                                                             <CheckIcon
                                                                                                                 style={{fontSize: "16px"}}
                                                                                                             />
                                                                                                            فعال
                                                                                                        </span>}
                                                                        {item.status === "completed" &&
                                                                            <span
                                                                                className="text-white flex gap-1">
                                                                                                               <CheckIcon
                                                                                                                   style={{fontSize: "16px"}}
                                                                                                               />

                                                                                                            انجام شده</span>}
                                                                        {item.status === "canceled" &&
                                                                            <span
                                                                                className="text-white flex gap-1">
                                                                                                             <CheckIcon
                                                                                                                 style={{fontSize: "16px"}}
                                                                                                             />
                                                                                                            لغو شده
                                                                                                        </span>}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    className="w-[40%] bg-gray-200 h-[26px] rounded-[7px] flex items-center text-[14px] font-medium justify-center gap-2 ">
                                                                    <p>{item.price - (item.price_paid ?? 0)}</p>
                                                                    <p>تومان</p>
                                                                </div>
                                                                <div
                                                                    className="w-[20%] bg-gray-200 h-[26px] rounded-[7px] flex items-center justify-center gap-1">
                                                                    <img
                                                                        alt=""
                                                                        className="w-[15px] h-[15px]"
                                                                        src={timeimg}
                                                                    />
                                                                    <p className=" xsm:text-[12px] text-[14px] sm:text-[12px] lg:text-[12px] font-medium pt-1 ">
                                                                        {item.travel_hour_time}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>))}
                                                    </div>))}
                                            </>) :
                                            (<div className="h-full flex items-center justify-center">
                                                {errorhistoryt ? (
                                                        <p>{errorhistoryt}!</p>)
                                                    : (historyloading === true && (
                                                        <div className="mt-4">
                                                            <Loadingcom/>
                                                        </div>))}
                                            </div>)}
                                    </>
                                </div>)}


                            {showhis === false && showtrinprogress === true && (<>
                                {activeloading ?
                                    (<div
                                        className="h-full flex items-center justify-center">
                                        {erroractivet ?
                                            (
                                                <p>{erroractivet}!</p>)
                                            :
                                            (activeloading === true && (
                                                <div className="mt-4">
                                                    <Loadingcom/>
                                                </div>))}
                                    </div>)
                                    :
                                    (<div className="h-full ">
                                        {noActiveTravel === false ?
                                            (<div
                                                className={`${showexit === false ? "cursor-pointer" : ""} mt-8 p-2 bg-white rounded-[10px] mx-4 shadow-md border-[1px] border-gray-200`}
                                                onClick={showexit === false ? () => handleshowhistroyprogress(allactivetravel) : null}
                                            >
                                                <div className='flex justify-center items-center py-1 gap-3'>
                                                    <div
                                                        className=" flex  items-center ml-4 ">
                                                        <div
                                                            className="  w-[10px] h-[10px] border-[2px] border-bordercircle rounded-[50%] "></div>

                                                        <p className="text-[14px] font-normal pr-2">
                                                            {allactivetravel.origin_city?.name}
                                                        </p>
                                                    </div>

                                                    <div
                                                        className="flex items-center gap-1 ">
                                                        <div
                                                            className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]"></div>
                                                        <div
                                                            className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]"></div>
                                                        <div
                                                            className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]  "></div>
                                                        <div
                                                            className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]  "></div>
                                                        <div
                                                            className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]  "></div>
                                                        <div
                                                            className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]  "></div>
                                                        <div
                                                            className="w-[4px] h-[4px] rounded-[50%] bg-bordercircle my-[2px]  "></div>
                                                        <div
                                                            className="mt-[3px] font-black text-xl text-bordercircle">&gt;</div>
                                                    </div>
                                                    <div
                                                        className=" flex  items-center mr-4 ">
                                                        <div
                                                            className="w-[10px] h-[10px] rounded-[2px]  bg-bordercircle flex justify-center items-center">
                                                            <div
                                                                className="bg-white rounded-[2px] w-[6px] h-[6px]"></div>
                                                        </div>
                                                        <p className="text-[14px] font-normal pr-2">
                                                            {allactivetravel.destination_city?.name}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div
                                                    className="h-[1px] bg-lightline mx-4 mt-2"></div>
                                                <div
                                                    className=" row-span-1  grid grid-cols-2 mr-4 ">
                                                    <div
                                                        className="col-span-1 h-[40px] flex ">
                                                        <div
                                                            className=" items-center  flex  text-[16px] ">
                                                            <p>{allactivetravel.price - (allactivetravel.price_paid ?? 0)}</p>
                                                            <p className="pr-1">تومان</p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="col-span-1 flex justify-end h-[40px] items-center text-[12px]  font-medium">
                                                        <p className="text-[13px] font-black text-[#FFBF18FF]">
                                                            جزئیات
                                                        </p>

                                                        <div
                                                            className="ml-4 cursor-pointer ">
                                                            <img
                                                                alt=""
                                                                src={leftarrow}
                                                                className="pr-2"
                                                            ></img>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>)
                                            :
                                            (<div
                                                className="w-full h-full flex items-center justify-center">
                                                <p>شما سفر فعال ندارید !</p>
                                            </div>)
                                        }
                                    </div>)}
                            </>)}


                        </>)}
                    </div>)}
                </>)}
            </>) : (<div className=" h-full w-full flex flex-col   items-center justify-center ">
                <>
                    <div
                        id="traveldiv"
                        className=" flex  items-center justify-center  "
                    >
                        <p className="text-[20px] text-center  text-[black] font-bold">
                            در انتظار دریافت اطلاعات ...
                        </p>
                    </div>
                </>
            </div>)}
        </>) : (navigate("/"))}
    </>);
};
export default Historycom;
